import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import BaseAdapter from '../base/BaseAdapter';
window.kraken && window.kraken.methodChannel.setMethodCallHandler(function (callbackMethod, callbackArgs) {
  var callbackFunc = window[callbackMethod];
  if (callbackFunc) {
    console.log("invoke callback name=".concat(callbackMethod), "state=".concat(callbackArgs.invokeState), "param=".concat(callbackArgs.invokeParam));
    callbackFunc(callbackArgs.invokeState, callbackArgs.invokeParam);
  }
});
function invokeNative(method, params, callback) {
  console.log("invoke native method=".concat(method), "params=".concat(params));
  var timestamp = new Date().getTime();
  var callbackName = "".concat(method, "_callback_").concat(timestamp);
  window[callbackName] = function (state, res) {
    if (callback) {
      callback(state, res);
    }
    delete window[callbackName];
  };
  if (params == undefined) {
    params = {};
  }
  params.callback = callbackName;
  window.kraken.methodChannel.invokeMethod(method, JSON.stringify(params));
}
var KrakenAdapter = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(KrakenAdapter, _BaseAdapter);
  var _super = _createSuper(KrakenAdapter);
  function KrakenAdapter() {
    _classCallCheck(this, KrakenAdapter);
    return _super.call(this);
  }
  _createClass(KrakenAdapter, [{
    key: "close",
    value: function close() {
      invokeNative('close');
    }
  }, {
    key: "enterDetail",
    value: function enterDetail(obj, callback) {
      invokeNative('enterInfoDetail', obj, callback);
    }
  }, {
    key: "enterUnifiedUrl",
    value: function enterUnifiedUrl(obj, callback) {
      invokeNative('jumpEntrance', obj, callback);
    }
  }, {
    key: "getStatusBarHeight",
    value: function getStatusBarHeight(obj, callback) {
      invokeNative('getStatusBarHeight', obj, callback);
    }
  }, {
    key: "callPhoneNumber",
    value: function callPhoneNumber(obj, callback) {
      invokeNative('callPhoneNumber', obj, callback);
    }
  }, {
    key: "checkPackageInstalled",
    value: function checkPackageInstalled(obj, callback) {
      invokeNative('checkPackageInstalled', obj, callback);
    }
  }, {
    key: "closeCaptureTorch",
    value: function closeCaptureTorch(obj, callback) {
      invokeNative('closeCaptureTorch', obj, callback);
    }
  }, {
    key: "getNetworkTypeAndOperator",
    value: function getNetworkTypeAndOperator(obj, callback) {
      invokeNative('getNetworkTypeAndOperator', obj, callback);
    }
  }, {
    key: "getPhoneInfo",
    value: function getPhoneInfo(obj, callback) {
      invokeNative('getPhoneInfo', obj, callback);
    }
  }, {
    key: "isStatusBarSupportDarkMode",
    value: function isStatusBarSupportDarkMode(obj, callback) {
      invokeNative('isStatusBarSupportDarkMode', obj, callback);
    }
  }, {
    key: "openCaptureTorch",
    value: function openCaptureTorch(obj, callback) {
      invokeNative('openCaptureTorch', obj, callback);
    }
  }, {
    key: "openSysPushSetting",
    value: function openSysPushSetting(obj, callback) {
      invokeNative('openSysPushSetting', obj, callback);
    }
  }, {
    key: "openSystemPermissionSetting",
    value: function openSystemPermissionSetting(obj, callback) {
      invokeNative('openSystemPermissionSetting', obj, callback);
    }
  }, {
    key: "openUrlInSysBrower",
    value: function openUrlInSysBrower(obj, callback) {
      invokeNative('openUrlInSysBrower', obj, callback);
    }
  }, {
    key: "playVideoBySystem",
    value: function playVideoBySystem(obj, callback) {
      invokeNative('playVideoBySystem', obj, callback);
    }
  }, {
    key: "setKeyboardFrameChangeCallback",
    value: function setKeyboardFrameChangeCallback(obj, callback) {
      invokeNative('setKeyboardFrameChangeCallback', obj, callback);
    }
  }, {
    key: "setPageCallback",
    value: function setPageCallback(obj, callback) {
      invokeNative('setPageCallback', obj, callback);
    }
  }, {
    key: "setPageResult",
    value: function setPageResult(obj, callback) {
      invokeNative('setPageResult', obj, callback);
    }
  }, {
    key: "setStatusBarDarkMode",
    value: function setStatusBarDarkMode(obj, callback) {
      invokeNative('setStatusBarDarkMode', obj, callback);
    }
  }, {
    key: "systemShake",
    value: function systemShake(obj, callback) {
      invokeNative('systemShake', obj, callback);
    }
  }, {
    key: "hasSupportFeature",
    value: function hasSupportFeature(obj, callback) {
      invokeNative('hasSupportFeature', obj, callback);
    }
  }, {
    key: "requestLocation",
    value: function requestLocation(obj, callback) {
      invokeNative('requestLocation', obj, callback);
    }
  }]);
  return KrakenAdapter;
}(BaseAdapter);
KrakenAdapter.pluginName = 'KrakenAdapter';
KrakenAdapter.platform = [{
  rule: function rule() {
    return !!window.kraken;
  },
  name: 'kraken'
}];
export { KrakenAdapter as default };